import { HandsIcon } from "../assets/hands-icon";
import { MentorIcon } from "../assets/mentor-icon";
import { PenAndPaperIcon } from "../assets/pen-and-paper-icon";
import { IKelasLiveFeaturesData } from "./trial-activation-modal.types";
import TrialActive from "public/assets/kelas-live/trial-active.svg";
import TrialExpired from "public/assets/kelas-live/package-expired.svg";
import { NextRouter } from "next/router";
import { constants } from "constants/constants";

export const KelasLiveFeaturesData: IKelasLiveFeaturesData[] = [
  {
    imgSrc: HandsIcon,
    alt: "hands-icon",
    title: "Ketemuan sesama CoFriends ambis",
    desc: "Bangun rasa percaya diri dan saling bantu di kelas yang seru."
  },
  {
    imgSrc: MentorIcon,
    alt: "mentor-icon",
    title: "Belajar Matematika, Fisika, dan Kimia",
    desc: "Dalami materi sama Guru Juara dan Mentor sampe ngerti."
  },
  {
    imgSrc: PenAndPaperIcon,
    alt: "pen-and-paper-icon",
    title: "Bangun kebiasaan berlatih",
    desc: "Latihan soal 15 menit tiap abis kelas biar tambah ngerti materinya. "
  }
];

export const TrialActivationStatusData = {
  trial_activated: {
    imgSrc: TrialActive,
    alt: "Trial is activated",
    title: (daysLeft?: number | null): string =>
      `Hore, coba gratis Kelas Live udah aktif selama ${daysLeft} hari! 😊`,
    desc: "Cek jadwal dan masuk ke Kelas Live yang bisa kamu coba.",
    actionButtonText: "Eksplor Kelas Live",
    actionButtonClick: (router: NextRouter) =>
      router.push({ pathname: constants.redirect_to.kelas_live_dashboard })
  },
  trial_expired: {
    imgSrc: TrialExpired,
    alt: "Trial is expired",
    title: (): string => "Coba gratis Kelas Live udah abis 😢",
    desc: "Langganan paket biar bisa lanjut belajar lagi, ya.",
    actionButtonText: "Cek paket belajar",
    actionButtonClick: (router: NextRouter) =>
      router.push({ pathname: constants.redirect_to.paket })
  },
  trial_active: {
    imgSrc: TrialActive,
    alt: "Trial is active",
    title: (daysLeft?: number | null): string =>
      `Kamu udah aktifin coba gratis Kelas Live, sisa ${daysLeft} hari lagi 😉`,
    desc: "Coba gratis ini cuma ada sekali. Ikut kelasnya, ya!",
    actionButtonText: "Eksplor Kelas Live",
    actionButtonClick: (router: NextRouter) =>
      router.push({ pathname: constants.redirect_to.kelas_live_dashboard })
  },
  paid_expired: {
    imgSrc: TrialExpired,
    alt: "Free after paid",
    title: (): string => "Paket belajarmu udah abis 🙁 Langganan lagi, yuk!",
    desc: "Biar bisa belajar lagi sama Guru Juara, Mentor, dan temen.",
    actionButtonText: "Cek paket belajar",
    actionButtonClick: (router: NextRouter) =>
      router.push({ pathname: constants.redirect_to.paket })
  }
};
